<template>
  <section class="section container pt-3">
    <div class="mt-0 mb-6">
      <h1 class="title is-4 mb-3">
        {{ $t("landing module settings") }}
      </h1>
    </div>
    <form class="mt-5">
      <div class="columns">
        <div class="column">
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_replace_login"
              v-model="meta.replace_login"
            />
            <label for="chk_replace_login">{{
              $t("replace login as home page?")
            }}</label>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('default page')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/landing/page/catalog"
              name_field="name"
              value_field="name"
              @selected="page_changed"
              ref="page_dropdown"
            />
          </div>
        </div>
      </div>
    </form>
    <!-- <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="profiles"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="user icon" aria-hidden="true"></i>
            <span>{{ $t("connection profiles") }}</span>
          </a>
        </li>
        <li data-tab="processes" @click="change_active_tab($event, this)">
          <a>
            <i class="list icon" aria-hidden="true"></i>
            <span>{{ $t("processes") }}</span>
          </a>
        </li>
      </ul>
    </div> -->
    <!-- <div class="is-fluid" ref="contents"> -->
    <!-- <div class="" data-tab="profiles"> -->
    <!-- <profiles-datatable /> -->
    <!-- </div> -->
    <!-- <div class="is-hidden" data-tab="processes">
        <processes-datatable class="" />
      </div>
    </div> -->

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
  error_message,
  change_active_tab,
} from "@/utils";
import { isEmpty } from "lodash";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { v4 } from "uuid";

export default {
  name: "LandingSettings",
  components: {
    GenericDropdown,
  },
  data() {
    return {
      meta: { profiles: [] },
    };
  },
  methods: {
    change_active_tab,
    save() {
      let v = this;
      let data = { ...v.meta };
      v.$root.loader(true);
      save_configuration(v, data)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    page_changed(page) {
      let v = this;
      if (page && !isEmpty(page)) {
        v.meta.default_page = page.name;
      } else {
        v.meta.default_page = "";
      }
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf && !isEmpty(conf)) v.meta = conf;

        if (conf && conf.default_page)
          v.$refs.page_dropdown.set_value(conf.default_page);
      })
      .catch((error) => {
        error_message(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
